export function hasMeaningfulValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== "";
}

export function fieldHasValue(node) {
  if (!node || typeof node !== "object") return false;

  const props = node.props || {};
  if (node.element === "input") {
    if (props.type === "radio" || props.type === "checkbox") {
      return !!props.checked;
    }
    if (props.type === "file") {
      return Array.isArray(props.fileFields) && props.fileFields.length > 0;
    }
    return hasMeaningfulValue(props.value) || hasMeaningfulValue(props.defaultValue);
  }

  if (node.element === "select" || node.element === "textarea") {
    return hasMeaningfulValue(props.value) || hasMeaningfulValue(props.defaultValue);
  }

  if (Array.isArray(node.children)) {
    return node.children.some(fieldHasValue);
  }

  return false;
}

export function collectCheckboxInputs(node, collected = []) {
  if (!node || typeof node !== "object") return collected;

  if (node.element === "input" && node.props?.type === "checkbox") {
    collected.push(node);
  }

  if (Array.isArray(node.children)) {
    node.children.forEach((child) => collectCheckboxInputs(child, collected));
  }

  return collected;
}

export function toggleCheckboxInput(node, checkboxIndex = -1) {
  const checkboxInputs = collectCheckboxInputs(node);
  if (checkboxInputs.length === 0) return;

  const safeIndex =
    checkboxIndex >= 0 && checkboxIndex < checkboxInputs.length
      ? checkboxIndex
      : 0;

  const checkboxInput = checkboxInputs[safeIndex];
  checkboxInput.props = checkboxInput.props || {};
  checkboxInput.props.checked = !checkboxInput.props.checked;
}
